/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ClinicalNotesConsentAliases {
  BUTTON_CANCEL_CONFIRM_REFUSAL = 'button-cancel-confirm-refusal',
  BUTTON_CANCEL_CONSENT_WITHOUT_RECORDING = 'button-cancel-consent-without-recording',
  BUTTON_CONFIRM_CONSENT_WITHOUT_RECORDING = 'button-confirm-consent-without-recording',
  BUTTON_CONFIRM_REFUSAL = 'button-confirm-refusal',
  CANCEL_REFULSA_BUTTON = 'cancel-refulsa-button',
  CLINICAL_NOTES_MODAL = 'clinical-notes-modal',
  CLINICAL_NOTES_OPTIONS_MODAL_PANEL = 'clinical-notes-options-modal-panel',
  CONFIRM_REFUSAL_BUTTON = 'confirm-refusal-button',
  CONTINUE_BUTTON = 'continue-button',
  FIELD_COLLECT_CONSENT = 'field-collect-consent',
  FORM_COLLECT_CONSENT = 'form-collect-consent',
  GLOBAL_ACTIONS_CONFIRM_REFUSAL = 'global-actions-confirm-refusal',
  GLOBAL_ACTIONS_CONSENT_WITHOUT_RECORDING = 'global-actions-consent-without-recording',
  GLOBAL_ACTIONS_RECORD = 'global-actions-record',
  GLOBAL_ACTIONS_REFUSAL = 'global-actions-refusal',
  LAYOUT_CLINICAL_NOTES_CONSENT = 'layout-clinical-notes-consent',
  MODAL_COLLECT_CONSENT = 'modal-collect-consent',
  MODAL_CONFIRM_REFUSAL = 'modal-confirm-refusal',
  MODAL_CONSENT_WITHOUT_RECORDING = 'modal-consent-without-recording',
  MODAL_REFUSAL = 'modal-refusal',
  PANEL_COLLECT_CONSENT = 'panel-collect-consent',
  PANEL_COLLECT_CONSENT_CONTENT = 'panel-collect-consent-content',
  PANEL_COLLECT_CONSENT_FORM = 'panel-collect-consent-form',
  PANEL_CONFIRM_REFUSAL = 'panel-confirm-refusal',
  PANEL_CONFIRM_REFUSAL_CONTENT = 'panel-confirm-refusal-content',
  PANEL_CONFIRM_REFUSAL_CONTENT_TEXT = 'panel-confirm-refusal-content-text',
  PANEL_CONSENT_WITHOUT_RECORDING = 'panel-consent-without-recording',
  PANEL_CONTENT_CONSENT_WITHOUT_RECORDING = 'panel-content-consent-without-recording',
  PANEL_CONTENT_TEXT_CONSENT_WITHOUT_RECORDING = 'panel-content-text-consent-without-recording',
  PANEL_OPTIONS_MODAL = 'panel-options-modal',
  PANEL_REFUSAL = 'panel-refusal',
  PANEL_REFUSAL_MODAL = 'panel-refusal-modal',
  PANEL_REFUSAL_TEXT = 'panel-refusal-text',
  PANEL_TITLE_MODAL = 'panel-title-modal',
  RADIO_GROUP_COLLECT_CONSENT = 'radio-group-collect-consent',
  RECORD_OPTION = 'record-option',
  REFUSAL_TITLE_TEXT = 'refusal-title-text',
  REGISTER_REFUSAL_BUTTON = 'register-refusal-button',
  TEXT_COLLECT_CONSENT = 'text-collect-consent',
  TEXT_COLLECT_CONSENT_TITLE = 'text-collect-consent-title',
  TEXT_CONFIRM_REFUSAL = 'text-confirm-refusal',
  TEXT_CONSENT_WITHOUT_RECORDING = 'text-consent-without-recording',
  TEXT_REFUSAL = 'text-refusal',
  TEXT_TITLE = 'text-title',
  TEXT_TITLE_CONFIRM_REFUSAL = 'text-title-confirm-refusal',
  TEXT_TITLE_CONSENT_WITHOUT_RECORDING = 'text-title-consent-without-recording',
  WRITE_OPTION = 'write-option',
}
export { ClinicalNotesConsentAliases };
